<template>
  <b-container fluid class="bg-dark py-7 text-light" id="contact">
    <b-container>
      <b-row>
        <b-col md="12">
          <h2>Kontakt</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>Ihr findet uns auf folgenden Plattformen:</p>
        </b-col>
      </b-row>
      <b-row class="social-links my-3">
        <b-col md="6">
          <a
            href="https://www.facebook.com/JugendkircheMHL/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b-icon-facebook></b-icon-facebook>
          </a>
        </b-col>
        <b-col md="6">
          <a
            href="https://www.instagram.com/jugendkirche.muehlhausen/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b-icon-instagram></b-icon-instagram>
          </a>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name: "Contact",
};
</script>

<style lang="scss" scoped>
.social-links {
  font-size: 50pt;
  text-align: center;
  a {
    color: #ffc100;

    svg {
      transition: transform 0.3s ease;
      &:hover {
        transform: scale(1.2);
      }
    }
  }
}
</style>
